package com.milta.core.localization.translations.sq

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Hyrje",
    logout = "Dalje",
    email = "Email",
    password = "Fjalëkalim",
    showPassword = "Shfaq",
    hidePassword = "Fshih",
    roleSelectionTitle = "Krijo llogari",
    roleSelectionSubtitle = "Zgjidhni llojin e llogarisë që i përshtatet profilit tuaj",
    roleDriverTitle = "Unë jam shofer - korrjer",
    roleDriverDescription = "Ngis një automjet transporti ose dërgese dhe dua të optimizoj turet e mia",
    roleDriverTag1 = "Optimizo turet e mia",
    roleDriverTag2 = "Oferta Milta në rrugën time",
    roleEnterpriseTitle = "Unë jam ndërmarrje",
    roleEnterpriseDescription = "Kam numër TVSH dhe menaxhoj një flotë automjetesh dhe ekip shoferësh",
    roleEnterpriseTag1 = "Menaxhimi i flotës",
    roleEnterpriseTag2 = "Ndjekja e ekipeve",
    continueButton = "Vazhdoni",
    registerFormTitle = "Përfundoni regjistrimin",
    registerFormSubtitle = "Konfirmoni numrin tuaj të telefonit për të aktivizuar llogarinë tuaj.",
    registerFormSubtitleEnterprise = "Vendosni organizatën tuaj dhe një numër telefoni për të aktivizuar llogarinë tuaj.",
    googleAccountConnected = "Llogaria Google e lidhur",
    appleAccountConnected = "Llogaria Apple e lidhur",
    firstName = "Emri",
    lastName = "Mbiemri",
    phoneNumber = "Numri i telefonit",
    phoneNumberHelper = "Shkruani numrin e telefonit sipas dëshirës.",
    phoneNumberOtpInfo = "Një kod verifikimi do t'ju dërgohet me SMS për të konfirmuar këtë numër.",
    registerButton = "Merrni një kod verifikimi",
    passwordHint = "Të paktën 8 karaktere",
    registerSuccess = "Llogaria u krijua me sukses",
    errorEmailConflict = "Ky adresë emaili është tashmë në përdorim",
    errorPhoneConflict = "Ky numër telefoni është tashmë i regjistruar",
    errorPhoneChangeCooldown = "Mund ta ndryshoni numrin e telefonit vetëm një herë në 30 ditë",
    errorGeneric = "Lidhja dështoi. Kontrolloni rrjetin tuaj dhe provoni përsëri.",
    errorFirstNameRequired = "Ju lutemi shkruani emrin tuaj",
    errorFirstNameTooLong = "Emri nuk mund të kalojë 100 karaktere",
    errorLastNameRequired = "Ju lutemi shkruani mbiemrin tuaj",
    errorLastNameTooLong = "Mbiemri nuk mund të kalojë 100 karaktere",
    errorPhoneTooLong = "Numri i telefonit nuk mund të kalojë 20 karaktere",
    errorOAuthAccountExists = "Ky llogari është tashmë e lidhur me një llogari tjetër Milta. Provoni të hyni.",
    errorOAuthTokenInvalid = "Sesioni juaj ka skaduar. Ju lutemi hyni përsëri.",
    loginTitle = "Hyrje",
    loginTabPassword = "Fjalëkalim",
    loginTabPhone = "Telefon",
    loginButton = "Hyr",
    forgotPassword = "Keni harruar fjalëkalimin?",
    sendCodeButton = "Dërgo kodin",
    otpTitle = "Futni kodin",
    otpSubtitle = "Dërguam një kod 6-shifror në",
    otpVerifyButton = "Verifiko",
    otpResend = "Ridërgo kodin",
    otpResendPrefix = "Nuk keni marrë kodin?",
    otpWrongNumber = "Numër i gabuar?",
    otpModifyLink = "Ndrysho",
    forgotPasswordTitle = "Fjalëkalim i harruar",
    forgotPasswordSubtitle = "Futni emailin tuaj për të marrë një lidhje resetimi",
    forgotPasswordButton = "Dërgo lidhjen",
    forgotPasswordSuccess = "Kontrolloni kutinë tuaj postare",
    resetPasswordTitle = "Fjalëkalim i ri",
    resetPasswordSubtitle = "Zgjidhni një fjalëkalim të ri për llogarinë tuaj",
    resetPasswordNewLabel = "Fjalëkalim i ri",
    resetPasswordConfirmLabel = "Konfirmoni fjalëkalimin",
    resetPasswordButton = "Rivendos fjalëkalimin",
    resetPasswordSuccess = "Fjalëkalimi u rivendos. Tani mund të hyni.",
    errorPasswordTooShort = "Fjalëkalimi duhet të ketë të paktën 8 karaktere",
    errorPasswordTooLong = "Fjalëkalimi nuk mund të kalojë 128 karaktere",
    errorPasswordMismatch = "Fjalëkalimet nuk përputhen",
    errorTokenInvalid = "Kjo lidhje rivendosjeje është e pavlefshme ose ka skaduar. Kërkoni një të re.",
    errorEmailInvalid = "Ju lutemi shkruani nje adrese emaili te vlefshme",
    errorPhoneRequired = "Ju lutemi shkruani nje numer telefoni",
    errorInvalidCredentials = "Email ose fjalëkalim i gabuar. Përdorni 'Keni harruar fjalëkalimin?' nëse nevojitet.",
    errorInvalidOtp = "Kod i gabuar. Kontrolloni SMS-in ose kërkoni një të ri.",
    errorExpiredOtp = "Kodi skadoi. Kërkoni një të ri.",
    errorTooManyAttempts = "Shumë tentativa të dështuara. Provoni përsëri pas disa minutash.",
    errorResendLimit = "Shumë kërkesa ridërgimi. Provoni pas disa minutash.",
    otpResendIn = "Ridërgo në %d s",
    otpAttemptsLeft = "%d tentativa të mbetura",
    loginGreeting = "Mirë se u kthyet!",
    loginSubtitle = "Hyni në llogarinë tuaj Milta",
    loginSmsOption = "Merrni një kod SMS",
    noAccount = "Nuk keni ende llogari?",
    signUp = "Regjistrohu",
    organizationName = "Emri i organizatës",
    organizationNameRequired = "Ju lutem vendosni emrin e organizatës",
    registerNextButton = "Tjetër",
    passwordConfirm = "Konfirmo fjalëkalimin",
    passwordRuleUpper = "Një shkronjë e madhe",
    passwordRuleDigit = "Një shifër",
    passwordRuleSpecial = "Një karakter special",
    alreadyHaveAccount = "Keni tashmë llogari — Hyni",
)
